import React, { useEffect, useState } from 'react'
import Layout from '../../../components/common/pageLayout'
import { toast } from 'react-toastify'
import ListBuilder from '../../../components/MasterData/ShipYard/list'
import constant from '../../../constant'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { v3_shipyards, v3_shipyard_visibility } from '../../../actions/v3/masterData'
import { replacePageState } from '../../../utils';
const List = (props) => {
    const location = useLocation();
    const { page } = location.state || {};
    const [data, setData] = useState(null)
    const [currentPage, setCurrentPage] = useState(page ? page : 1)
    const [limit, setLimit] = useState(10)

    useEffect(() => {
        v3_shipyards(currentPage, limit).then((res) => {
            if (res.status) {
                setData(res.result);
                replacePageState(props.history, constant.Authedcomponent.listShipYardMasterData.url, {
                    page: currentPage
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }, [currentPage, limit])

    const onChangeVisibility = (record) => {
        const newStatus = !record.IS_ACTIVE; // toggle boolean

        v3_shipyard_visibility(record.ID, newStatus).then((res) => {
            if (res.status) {
                setData(prevState => ({
                    ...prevState,
                    shipyards: prevState.shipyards.map(item => {
                        if (item.ID === record.ID) {
                            return {
                                ...item,
                                IS_ACTIVE: newStatus
                            };
                        }
                        return item;
                    })
                }));

                toast.success(res.result.message);
            } else {
                toast.error("Failed to update shipyards visibility");
            }
        }).catch((err) => {
            console.error(err);
            toast.error("An error occurred while updating shipyards visibility");
        });
    };



    return (
        <Layout
            title={'Shipyard List'}
        >
            {data && <ListBuilder
                onChangeVisibility={onChangeVisibility}
                limit={limit}
                data={data}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
            />}
        </Layout>
    )
}

export default List